import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import WarrantyForm from '../warranty_form/WarrantyForm';
import { getEntityById } from '../../utils/DataAccessUtils';

const { Content } = Layout;

class NewWarrantyPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	render() {
		const { history } = this.props;
		return (
			<Content>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card>
							<div>
								<h4>New Warranty</h4>
								<WarrantyForm
									formData={{}}
									onSuccess={(asset) => history.push(`/buyer/assets/detail/${asset.id}`)}
								/>
							</div>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	asset: getEntityById(ownProps.match.params.id, state.assets),
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewWarrantyPage));
